/*
=================================
ACCOUNT URLS
=================================
*/

/**
 * Update personal profile url
 *
 * @returns url string
 *
 */

export const updateUserURL = () => `/auth/user/`;

/**
 * Create company profile url
 *
 * @returns url string
 *
 */

export const createCompanyURL = () => `/auth/company/`;

/**
 * Fetch user information url
 *
 * @returns url string
 *
 */

export const fetchUserURL = () => `/auth/user/`;

/**
 * Update company profile url
 *
 * @returns url string
 *
 */

export const updateCompanyURL = () => `/auth/company/`;

/**
 * Change password url
 *
 * @returns url string
 *
 */

export const changePasswordURL = () => `/auth/change-password/`;

/**
 * Fetch stats url
 *
 * @returns url string
 *
 */

export const fetchStatsURL = () => `/assessment/dashboard/overview-card/`;

/**
 * Fetch graph data url
 *
 * @returns url string
 *
 */

export const fetchGraphDataURL = (period: string) =>
  `/assessment/dashboard/graph/?period=${period}`;

export const markTourSeenURL = () => `/auth/tour/seen/`;
